import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, CircularProgress, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const CentralImportDialog = ({ open, title, message, actionLabel }) => {
  const { t } = useTranslation("products");
  const effectiveTitle =
    title || t("centralImport.titleDefault");
  const effectiveMessage =
    message || t("centralImport.messageDefault");
  const effectiveActionLabel = actionLabel || t("centralImport.actionLabelDefault");

  return (
    <Dialog open={open} onClose={() => {}} fullWidth maxWidth="sm">
      <DialogTitle>{effectiveTitle}</DialogTitle>
      <DialogContent dividers sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <CircularProgress size={24} />
        <Typography>{effectiveMessage}</Typography>
      </DialogContent>
      <DialogActions>
        <Button disabled>{effectiveActionLabel}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CentralImportDialog;
